export default function About() {
  return (
    <section id="about" className="relative w-full bg-cream-50 py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16 items-center">
          {/* Image */}
          <div className="lg:col-span-2 order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden">
              <div className="relative aspect-[4/5] w-full">
                <img
                  src="https://storage.readdy-site.link/project_files/564b8566-d4d5-4635-bf3c-ab9b4b833508/9ff762bd-f4db-4fa6-8d9f-27942a58dc8a_compressed_ChatGPT-Image-13-.-2026-.-15_08_38.webp"
                  alt="Trevica team collaboration"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-3 order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="w-2 h-2 rounded-full bg-amber-400"></span>
              <span className="text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-ink-700">
                About Us
              </span>
            </div>
            <h2 className="font-display font-bold text-ink-950 leading-[1.08] tracking-tight text-3xl md:text-4xl lg:text-5xl">
              Trevica LTD — where development meets marketing
            </h2>
            <p className="mt-5 text-sm md:text-base text-ink-700 leading-relaxed">
              We are an IT company specializing in the development of utility applications — from cleaners
              and optimizers to AI services — and their full-cycle promotion and advertising support.
            </p>
            <p className="mt-4 text-sm md:text-base text-ink-700 leading-relaxed">
              Our expertise spans several key areas: mobile and desktop utility development, IT consulting,
              and digital marketing services for applications. We help create tech-driven products and
              effectively bring them to market — from ASO and media buying to scaling user bases.
            </p>
            <p className="mt-4 text-sm md:text-base text-ink-700 leading-relaxed">
              We accompany projects at all stages — from idea and analytics through development, launch,
              promotion, and ongoing support. Thanks to our strong team of project managers, developers,
              UI/UX designers, marketers, and QA engineers, we unite development and marketing into a
              single application growth strategy.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}